export default function Features() {
  const features = [
    {
      color: "from-blue-500 to-cyan-400", // azul → cian
      title: "Reservas con IA",
      desc: "Simplemente di dónde y cuándo quieres ir. Nuestra IA se encarga del resto, encontrando el mejor horario disponible.",
      icon: "📅",
    },
    {
      color: "from-purple-500 to-pink-500", // morado → rosa
      title: "Gestión inteligente",
      desc: "Todas tus reservas en un solo lugar. Modifica, cancela o reprograma con un click. Recordatorios automáticos.",
      icon: "🧠",
    },
    {
      color: "from-orange-400 to-red-400", // naranja → rojo
      title: "Programa de fidelización",
      desc: "Acumula puntos en cada reserva. Canjea por descuentos, platos gratis y experiencias exclusivas.",
      icon: "🎁",
    },
    {
      color: "from-green-500 to-emerald-400",
      title: "Plan referidos",
      desc: "Permite que tus clientes frecuentes ganen más beneficios, invitando a sus amigos a reservar en tu bar o restaurante.",
      icon: "👥",
    },
    {
      color: "from-yellow-400 to-orange-500",
      title: "Asistente financiero inteligencia",
      desc: "Analiza Datos, genera estadisticas, identifica patrones y proyecta tendencias.",
      icon: "📈",
    },
    {
      color: "from-pink-500 to-purple-500",
      title: "Experiencias VIP",
      desc: "Accede a mesas exclusivas y promociones especiales solo para usuarios frecuentes.",
      icon: "⭐",
    },
  ];

  return (
    <section id="funciones" className="max-w-6xl mx-auto px-6 py-24 text-center">
      <h2 className="text-4xl font-extrabold mb-4">Todo lo que necesitas</h2>
      <p className="text-gray-600 max-w-2xl mx-auto mb-12">
        Buksy combina tecnología de vanguardia con simplicidad para transformar tu experiencia gastronómica.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((f) => (
          <div
            key={f.title}
            className="bg-white shadow-md rounded-2xl p-6 text-left transition-transform transform hover:scale-105 hover:shadow-xl duration-300"
          >
            <div
              className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-r ${f.color} text-white text-3xl shadow-md hover:shadow-lg transition-all transform hover:scale-110 duration-300`}
            >
              {f.icon}
            </div>

            <h3 className="mt-5 font-semibold text-lg">{f.title}</h3>
            <p className="text-gray-600 text-sm mt-2">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
